import React, { useEffect, useState } from "react";
import { useDebounce } from "../helpers/use-debounce";

const apiGetCityListNP = (search, locale, onSuccess) => {
  $.get(
    `/api/novaposhta/cities?locale=${locale}&q=${search}`,
    (response) => {
      onSuccess(response);
    },
    "json"
  );
};

function usePortal(id) {
  const rootElemRef = React.useRef(document.createElement("div"));

  useEffect(() => {
    const parentElem = document.querySelector(`#${id}`);
    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.remove();
    };
  }, [id]);

  return rootElemRef.current;
}


// Props:
//  title: string [Modal title]
//  info: string [Modal description]
//  isVisible: boolean
//  inputPlaceholder: string
//  onCityClick: fn
//  cityList: [
//    name: string
//  ]
const ModalCitySelector = (props) => {
  const { phrases } = window
  const { onCityClick } = props
  const { minSearchSymbols = 2, onSelectItem = onCityClick, toggleModal } = props
  const [localValue, setLocalValue] = useState(props.value);
  const debouncedValue = useDebounce(localValue, 500);
  const [result, setResult] = useState([]);
  const [isLoaded, setLoaded] = useState(true);

  const fetchData = (search, locale, onSuccess) => {
    if (props.cityList?.length) {

      onSuccess(props.cityList.filter(({ name }) => name.toLowerCase().startsWith(search.toLowerCase())) || []);
      return false;
    }
    // return apiGetCityListNP();
  };
  const handleCitySelect = (code, name) => {
    onSelectItem({
      code,
      name,
    });
    toggleModal();
  };

  useEffect(() => {
    if (props.cityList) {
      setResult(props.cityList);
      setLoaded(true);
    }
  }, [props.cityList]);

  useEffect(() => {
    if (localValue.length > 0) {
      setLocalValue("");
    }
  }, [props.isVisible]);

  // useEffect(() => {
  //   if (localValue.length > 1) {
  //     setLoaded(false);
  //   }
  // }, [localValue]);

  useEffect(() => {
    if (debouncedValue.length >= minSearchSymbols || debouncedValue.length === 0) {
      setLoaded(false);
      fetchData(debouncedValue, props.locale, (data) => {
        setResult(data);
        setLoaded(true);
      });
    } else {
      // setLoaded(true);
    }
  }, [debouncedValue]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  return props.isVisible ? (
    <div className="modal modal__city js_city_modal">
      <div className="modal__zoom">
        <div className="modal-content">
          <div className="close-btn" onClick={toggleModal} />
          <div className="modal-cart__content">
            <div className="modal-content__title">
              {props.title || "\u00A0"}
            </div>
            <div className="modal__city_info">{props.info}</div>
            <div className="modal__city_body">
              <input
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                className="modal__city_input checkout__input"
                type="text"
                placeholder={props.inputPlaceholder || "Search"}
                value={localValue}
                onChange={handleChange}
              />
              {isLoaded ? (
                <div className="modal__city_list">
                  {result.length > 0 &&
                    result.map((item, idx) => (
                      <div
                        key={item.id || item.code || idx}
                        className="modal__city_row"
                        onClick={() => handleCitySelect(item.code, item.name)}
                      >
                        {item.prefix}
                        {item.name}
                      </div>
                    ))}
                  {result.length === 0 && debouncedValue.length > 1 && (
                    <div className="modal__city_empty">{phrases?.shops?.['no_found'] || props.notFoundText || 'Not found'}</div>
                  )}
                </div>
              ) : (
                <div className="modal__city_list">
                  <div className="modal__city_row">{' '}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal__city_bg" onClick={toggleModal} />
    </div>
  ) : (
    ""
  )

};

export default ModalCitySelector;
